import styled, { css } from 'styled-components';

import {
  IconButton as BaseIconButton,
  StyledActionButton as BaseStyledActionButton,
} from './styled.base';

export * from './styled.base';

export const StyledActionButton = styled(BaseStyledActionButton)`
  font-family: ${Styles.fontFamily.body};
`;

export const IconButton = styled(BaseIconButton)<{ disabled?: boolean }>`
  ${p =>
    p.disabled &&
    css`
      path {
        fill: ${Styles.color.disabledColor};
      }
    `}
`;

export const fill = Styles.color.primary;
